import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrNordouestPage() {
  const data = arrondissementsData.find((a) => a.slug === "nord-ouest")!;
  return <ArrondissementPage data={data} />;
}
